export default __webpack_public_path__ + "static/media/bg-auth-overlay.175b126e.png";